import React from 'react'

const Experience = () => {
    return (
        <div className="experience" id="experience">
            <div className="experience-title">Experience</div>
            <div className="experience-text">
                <p className="tabbed-paragraph">
                    I've worked with a variety of technologies throughout under-graduate curriculumn, clubs, and personal projects. 
                    The technologies and languages below are emphasized in order of experience. 
                    Outside of these, I also have experience with 
                    <a className="inline-link" href="https://leetcode.com/u/ereinha/"> dynamic programming</a>, 
                    <a className="inline-link" href="https://github.com/ereinha3/Operating-Systems/tree/main/Project1"> OS management</a>, 
                    <a className="inline-link" href="https://github.com/ereinha3/Operating-Systems/tree/main/Project3"> parallelism</a>, 
                    <a className="inline-link" href="https://github.com/ereinha3/Introduction-to-Cryptography"> cryptography</a>, 
                    many Python libraries including PyTorch, 
                    <a className="inline-link" href="https://github.com/ereinha3/Watch-Profits-Soar-to-the-Ether"> TensorFlow</a>, 
                    and a versatile background in Applied Mathematics.
                </p>
            </div>
            <div className="experience-container">
                <div className="languages-container">
                    <div className="languages-title">
                        Languages
                    </div>
                    <div className="languages-list">
                        <div className="python large-3D-text">
                            Python
                        </div>
                        <div className="c large-3D-text">
                            C
                        </div>
                        <div className="js large-3D-text">
                            JavaScript
                        </div>
                        <div className="bash medium-3D-text">
                            Bash
                        </div>
                        <div className="cpp medium-3D-text">
                            C++
                        </div>
                        <div className="html medium-3D-text">
                            HTML
                        </div>
                        <div className="css medium-3D-text">
                            CSS
                        </div>
                        <div className="csharp medium-3D-text">
                            C#
                        </div>
                        <div className="swift small-3D-text">
                            Swift
                        </div>
                        <div className="scheme small-3D-text">
                            Scheme
                        </div>
                        <div className="sml small-3D-text">
                            SML
                        </div>
                        <div className="haskell small-3D-text">
                            Haskell
                        </div>
                    </div>
                </div>
                <div className="technologies-container">
                    <div className="technologies-title">
                        Technologies
                    </div>
                    <div className="technologies-list">
                        <div className="github large-3D-text">
                            GitHub
                        </div>
                        <div className="unity large-3D-text">
                            Unity
                        </div>
                        <div className="linux large-3D-text">
                            Linux
                        </div>
                        <div className="docker medium-3D-text">
                            Docker
                        </div>
                        <div className="react medium-3D-text">
                            React
                        </div>
                        <div className="top-[45%] left-[10%] medium-3D-text">
                            CUDA
                        </div>
                        <div className="top-[55%] right-[5%] medium-3D-text">
                            OpenMP
                        </div>
                        <div className="top-[75%] right-[35%] large-3D-text">
                            PyTorch
                        </div>
                        <div className="top-[80%] right-[15%] small-3D-text">
                            MPI
                        </div>
                        <div className=""></div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Experience;